var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"outlined":"","rules":_vm.rules,"label":_vm.$t('configurations.report_sensitivity')},model:{value:(_vm.sensitivity),callback:function ($$v) {_vm.sensitivity=$$v},expression:"sensitivity"}})}
var staticRenderFns = []

export { render, staticRenderFns }